export default function matchMediaDesktop(minWidth = '40em') {
  return window.matchMedia(`(min-width: ${minWidth})`).matches;
}



// WEBPACK FOOTER //
// ./src/utils/client_util.js